// extracted by mini-css-extract-plugin
export default {"dragBox":"DragNDrop_dragBox__IIeoO","dndBox":"DragNDrop_dndBox__cy2FC"};